import { useTranslation } from 'react-i18next';

const FEATURE_COUNT = 3;

export default function BasicTraining() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative w-full aspect-[4/3] overflow-hidden order-2 lg:order-1">
            <img
              src="/images/generated/training-basic-2026.jpg"
              alt={t('training.basic.imgAlt')}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            {String(t('training.basic.imgCaption')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[12px] text-foreground-400 tracking-[0.04em] mt-2 text-center">{__s}</p>))}
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            {String(t('training.basic.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
              {t('training.basic.sectionTitle')}
            </h2>
            {String(t('training.basic.sectionTitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
            <div className="gold-line mb-6"></div>

            {String(t('training.basic.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-6">{__s}</p>))}

            <div className="space-y-4">
              {Array.from({ length: FEATURE_COUNT }, (_, idx) => (
                <div key={idx} className="flex gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-[15px] text-foreground-800 tracking-[0.04em] font-medium mb-1">
                      {t(`training.basic.${idx}.title`)}
                    </h4>
                    <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                      {t(`training.basic.${idx}.description`)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
